(function () {
  'use strict';

  /* ── DATA ── */
  var PKGS = {
    1: { name: '1 Bucată',  price: 49,  save: '',                      transport: 19, slots: 1 },
    2: { name: '2 Bucăți', price: 89, save: 'Economisești 39,90 lei', transport: 19, slots: 2 },
    3: { name: '3 Bucăți', price: 129, save: 'Transport GRATUIT',      transport: 0,  slots: 3 }
  };

  /* Variant map populated by Shopify section via window.BB_VARIANTS */
  /* Format: { '1-M': variantId, '1-L': variantId, '2-M': variantId, ... } */

  var selPkg = 0;
  var sizes  = {};
  var qty    = 1;

  /* ── HELPERS ── */
  function el(id)  { return document.getElementById(id); }
  function qs(sel) { return document.querySelector(sel); }
  function qsa(sel){ return document.querySelectorAll(sel); }

  /* ── OVERLAY ── */
  function openFresh() {
    selPkg = 0; sizes = {}; qty = 1;
    showStep(1);
    el('bbOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
    document.dispatchEvent(new Event('bb:popupOpened'));
  }

  function openWithPkg(n) {
    selPkg = parseInt(n); sizes = {}; qty = 1;
    showStep(2);
    el('bbOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
    document.dispatchEvent(new Event('bb:popupOpened'));
  }

  function closePopup() {
    el('bbOverlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── STEPS ── */
  function showStep(n) {
    el('bbStep1').style.display = n === 1 ? 'block' : 'none';
    el('bbStep2').style.display = n === 2 ? 'block' : 'none';
    if (n === 2) buildStep2();
  }

  function buildStep2() {
    var pkg = PKGS[selPkg];

    el('bbS2Name').textContent  = pkg.name;
    el('bbS2Save').textContent  = pkg.save;
    el('bbS2Price').textContent = pkg.price + ' lei';

    /* Build size selectors */
    var wrap = el('bbSizeSlots');
    wrap.innerHTML = '';
    sizes = {};

    for (var i = 1; i <= pkg.slots; i++) {
      (function (slot) {
        sizes[slot] = '';
        var lbl = pkg.slots === 1 ? 'Alege mărimea' : 'Mărimea bucată ' + slot;
        var div = document.createElement('div');
        div.className = 'bb-pop-size-group';
        div.innerHTML =
          '<div class="bb-pop-size-label">' + lbl + '</div>' +
          '<div class="bb-pop-sizes">' +
            '<div class="bb-pop-sz" id="bbSz' + slot + 'M">' +
              '<div class="bb-pop-sz-m">M</div><div class="bb-pop-sz-s">70–90 cm</div>' +
            '</div>' +
            '<div class="bb-pop-sz" id="bbSz' + slot + 'L">' +
              '<div class="bb-pop-sz-m">L</div><div class="bb-pop-sz-s">90–110 cm</div>' +
            '</div>' +
          '</div>';
        wrap.appendChild(div);
        el('bbSz' + slot + 'M').addEventListener('click', function () { setSize(slot, 'M'); });
        el('bbSz' + slot + 'L').addEventListener('click', function () { setSize(slot, 'L'); });
      })(i);
    }

    /* Qty row — only pkg 1 */
    var qRow = el('bbQtyRow');
    if (selPkg === 1) {
      qty = 1;
      qRow.style.display = 'flex';
      el('bbQtyNum').textContent = '1';
    } else {
      qRow.style.display = 'none';
      qty = 1;
    }

    syncCost();
  }

  function setSize(slot, s) {
    var pkg = PKGS[selPkg];
    sizes[slot] = s;
    for (var i = 1; i <= pkg.slots; i++) {
      var m = el('bbSz' + i + 'M');
      var l = el('bbSz' + i + 'L');
      if (m) m.classList.toggle('active', sizes[i] === 'M');
      if (l) l.classList.toggle('active', sizes[i] === 'L');
    }
    syncCost();
  }

  function syncCost() {
    var pkg   = PKGS[selPkg];
    var prod  = selPkg === 1 ? pkg.price * qty : pkg.price;
    var trans = pkg.transport;
    var total = prod + trans;

    el('bbCostProd').textContent  = prod + ' lei';
    var tEl = el('bbCostTrans');
    if (trans === 0) { tEl.textContent = 'GRATUIT'; tEl.classList.add('free'); }
    else             { tEl.textContent = trans + ' lei'; tEl.classList.remove('free'); }
    el('bbCostTotal').textContent = total + ' lei';

    if (selPkg === 1) {
      el('bbQtyLbl').textContent = qty + ' bucată' + (qty > 1 ? 'ți' : '') + ' × ' + pkg.price + ' lei';
    }
  }

  function confirmOrder() {
    var pkg = PKGS[selPkg];
    /* Validate */
    for (var i = 1; i <= pkg.slots; i++) {
      if (!sizes[i]) {
        alert('Te rugăm să alegi mărimea pentru ' + (pkg.slots > 1 ? 'bucata ' + i : 'centură') + '!');
        return;
      }
    }

    /* Build Shopify cart add */
    var varMap = window.BB_VARIANTS || {};
    var items  = [];

    if (selPkg === 1) {
      var key = '1-' + sizes[1];
      var vid = varMap[key];
      if (vid) items.push({ id: parseInt(vid), quantity: qty });
    } else {
      /* For multi-slot, group identical sizes */
      var counts = {};
      for (var j = 1; j <= pkg.slots; j++) {
        var sz = sizes[j];
        counts[sz] = (counts[sz] || 0) + 1;
      }
      for (var sz in counts) {
        var vkey = selPkg + '-' + sz;
        var vvid = varMap[vkey];
        if (vvid) items.push({ id: parseInt(vvid), quantity: counts[sz] });
      }
    }

    if (items.length && items[0].id) {
      var btn = el('bbPopCta');
      if (btn) { btn.disabled = true; btn.textContent = 'Se procesează...'; }

      /* Golește coșul înainte de a adăuga noua selecție,
         ca la checkout să ajungă mereu doar pachetul curent ales. */
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          var promises = items.map(function (item) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(item)
            });
          });
          return Promise.all(promises);
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (e) {
          console.error(e);
          if (btn) { btn.disabled = false; btn.textContent = '🛒 CUMPĂRĂ ACUM'; }
          alert('A apărut o eroare. Te rugăm încearcă din nou.');
        });
    } else {
      /* Fallback: no variants configured */
      var sStr = '';
      for (var k = 1; k <= pkg.slots; k++) sStr += (pkg.slots > 1 ? 'Buc.' + k + ':' : '') + sizes[k] + (k < pkg.slots ? ' ' : '');
      alert('✓ Adăugat în coș!\nPachet: ' + pkg.name + '\nMărimi: ' + sStr + '\nTotal: ' + (pkg.price + pkg.transport) + ' lei\n\n(Configurează BB_VARIANTS în temă pentru cart real)');
      closePopup();
    }
  }

  /* ── URGENȚĂ: STOC + COUNTDOWN (bară sus) ──
     Determinist, bazat pe ora curentă — toți vizitatorii văd
     același număr în aceeași zi. Stocul scade treptat spre
     seară, iar la miezul nopții totul se resetează automat
     (stoc + countdown), simulând o "restocare" zilnică. */
  function updateTopbar() {
    var cfg = window.BB_TOPBAR || { stockStart: 50, stockMin: 3 };
    var now = new Date();
    var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    var endOfDay   = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    var elapsed = now - startOfDay;
    var total   = endOfDay - startOfDay;
    var frac    = elapsed / total; /* 0 la miezul nopții -> 1 chiar înainte de resetare */

    var stock = Math.round(cfg.stockStart - frac * (cfg.stockStart - cfg.stockMin));
    stock = Math.max(cfg.stockMin, Math.min(cfg.stockStart, stock));
    var stockEl = el('bbStockCount');
    if (stockEl) stockEl.textContent = 'Mai sunt ' + stock + ' bucăți';

    var remain = endOfDay - now;
    var hh = Math.floor(remain / 3600000);
    var mm = Math.floor((remain % 3600000) / 60000);
    var ss = Math.floor((remain % 60000) / 1000);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var timerEl = el('bbCountdown');
    if (timerEl) timerEl.textContent = 'Expiră în ' + pad(hh) + ':' + pad(mm) + ':' + pad(ss);
  }

  /* ── GALERIE FOTO PRODUS (popup) ── */
  function initGallery() {
    var imgs = window.BB_GALLERY || [];
    var wrap = el('bbGallery');
    if (!wrap || !imgs.length) return;

    var track = el('bbGalleryTrack');
    var dots  = el('bbGalDots');
    var prev  = el('bbGalPrev');
    var next  = el('bbGalNext');
    var idx   = 0;

    track.innerHTML = imgs.map(function (src) {
      return '<div class="bb-gallery-slide"><img src="' + src + '" alt="BINIBINI produs" loading="lazy"></div>';
    }).join('');

    dots.innerHTML = imgs.map(function (_, i) {
      return '<div class="bb-gallery-dot' + (i === 0 ? ' active' : '') + '" data-i="' + i + '"></div>';
    }).join('');

    wrap.style.display = 'block';
    if (imgs.length <= 1) {
      prev.style.display = 'none';
      next.style.display = 'none';
      dots.style.display = 'none';
    }

    function go(i) {
      idx = (i + imgs.length) % imgs.length;
      var w = wrap.clientWidth;
      track.style.transform = 'translateX(-' + (idx * w) + 'px)';
      qsa('.bb-gallery-dot').forEach(function (d, di) {
        d.classList.toggle('active', di === idx);
      });
    }

    prev.addEventListener('click', function () { go(idx - 1); });
    next.addEventListener('click', function () { go(idx + 1); });
    qsa('.bb-gallery-dot').forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-i'), 10)); });
    });

    /* Swipe pe mobil */
    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (dx > 40) go(idx - 1);
      else if (dx < -40) go(idx + 1);
      startX = null;
    });

    /* Re-poziționează corect la deschiderea popup-ului (dimensiune corectă abia atunci) */
    document.addEventListener('bb:popupOpened', function () { go(idx); });
  }

  /* ── HERO SLIDESHOW (autoplay + manual, orice device) ── */
  function initHeroSlider() {
    var wrap  = el('bbHeroSlider');
    var track = el('bbHeroTrack');
    if (!wrap || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.bb-hero-slide'));
    var count  = slides.length;
    if (count <= 1) return;

    var dotsWrap  = el('bbHeroDots');
    var prevBtn   = el('bbHeroPrev');
    var nextBtn   = el('bbHeroNext');
    var idx       = 0;
    var timer     = null;
    var animating = false;
    var AUTOPLAY_MS = 4500;
    var FLIP_MS      = 650;

    /* Pozitionare initiala: prima poza deasupra, restul ascunse dedesubt */
    slides.forEach(function (s, i) {
      s.style.zIndex = i === 0 ? '2' : '0';
      s.style.transform = 'rotateY(0deg)';
    });

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'bb-hero-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('data-i', i);
        d.setAttribute('aria-label', 'Imaginea ' + (i + 1));
        dotsWrap.appendChild(d);
      }
    }

    function setActiveDot(i) {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.bb-hero-dot').forEach(function (d, di) {
        d.classList.toggle('active', di === i);
      });
    }

    /* Efect "intoarcere pagina" (flip 3D): pagina curenta se roteste
       pe axa Y ca si cum ai da pagina, dezvaluind imaginea urmatoare
       asezata dedesubt. "next" se intoarce din stanga, "prev" din dreapta. */
    function go(newIdx, dir) {
      newIdx = (newIdx + count) % count;
      if (newIdx === idx || animating) return;
      animating = true;

      var outgoing = slides[idx];
      var incoming = slides[newIdx];
      if (!dir) dir = 'next';

      /* pregatim poza urmatoare: complet vizibila, sub pagina curenta */
      incoming.style.transition = 'none';
      incoming.style.transformOrigin = 'left center';
      incoming.style.transform  = 'rotateY(0deg)';
      incoming.style.zIndex     = '1';
      void incoming.offsetWidth; /* forteaza reflow inainte de a repune tranzitia */
      incoming.style.transition = '';

      /* pornim intoarcerea paginii curente */
      outgoing.style.zIndex = '2';
      outgoing.style.transformOrigin = dir === 'next' ? 'left center' : 'right center';
      void outgoing.offsetWidth;
      outgoing.style.transform = dir === 'next' ? 'rotateY(-130deg)' : 'rotateY(130deg)';

      setActiveDot(newIdx);
      idx = newIdx;

      setTimeout(function () {
        /* resetam pagina intoarsa, fara animatie, gata pentru urmatorul ciclu */
        outgoing.style.transition = 'none';
        outgoing.style.transform  = 'rotateY(0deg)';
        outgoing.style.zIndex     = '0';
        void outgoing.offsetWidth;
        outgoing.style.transition = '';
        incoming.style.zIndex     = '2';
        animating = false;
      }, FLIP_MS + 40);
    }

    function next() { go(idx + 1, 'next'); }

    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, AUTOPLAY_MS);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1, 'prev'); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1, 'next'); restart(); });
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.bb-hero-dot').forEach(function (d) {
        d.addEventListener('click', function () {
          var target = parseInt(d.getAttribute('data-i'), 10);
          var diff = (target - idx + count) % count;
          var dir = diff <= count / 2 ? 'next' : 'prev';
          go(target, dir);
          restart();
        });
      });
    }

    /* Swipe manual pe mobil / tabletă — tot cu efect de pagina intoarsa */
    var startX = null;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      if (timer) clearInterval(timer);
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (dx > 40) go(idx - 1, 'prev');
      else if (dx < -40) go(idx + 1, 'next');
      startX = null;
      restart();
    });

    /* Drag manual pe desktop cu mouse */
    var mouseDownX = null;
    track.addEventListener('mousedown', function (e) {
      mouseDownX = e.clientX;
      if (timer) clearInterval(timer);
    });
    window.addEventListener('mouseup', function (e) {
      if (mouseDownX === null) return;
      var dx = e.clientX - mouseDownX;
      if (dx > 40) go(idx - 1, 'prev');
      else if (dx < -40) go(idx + 1, 'next');
      mouseDownX = null;
      restart();
    });

    restart();
  }

  /* ── VIDEO "DE CE BINIBINI" — autoplay fiabil pe orice device, nu ramane blocat ── */
  function initWhyVideo() {
    var video = el('bbWhyVideo') || (qs('.bb-why-video-wrap') ? qs('.bb-why-video-wrap').querySelector('video') : null);
    if (!video) return;

    /* Setari native obligatorii pentru autoplay mut pe mobil (mai ales iOS) */
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function tryPlay() {
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* blocat de browser — se reincearca la evenimentele de mai jos */ });
      }
    }

    tryPlay();
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('canplay', tryPlay);
    video.addEventListener('ended', tryPlay); /* siguranta suplimentara peste loop */

    /* Reia redarea cand tab-ul / aplicatia revine in prim-plan */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tryPlay();
    });

    /* Multe browsere mobile permit autoplay abia dupa prima interactiune a userului */
    function resumeOnInteract() {
      tryPlay();
      document.removeEventListener('touchstart', resumeOnInteract);
      document.removeEventListener('click', resumeOnInteract);
      document.removeEventListener('scroll', resumeOnInteract);
    }
    document.addEventListener('touchstart', resumeOnInteract, { passive: true });
    document.addEventListener('click', resumeOnInteract);
    document.addEventListener('scroll', resumeOnInteract, { passive: true });

    /* Plasa de siguranta: daca ramane blocat/in pauza fara motiv, reia periodic */
    setInterval(function () {
      if (video.paused && !video.ended) tryPlay();
    }, 4000);
  }

  /* ── EVENTS ── */
  function init() {
    /* Close */
    var ox = el('bbClose');
    if (ox) ox.addEventListener('click', closePopup);
    var ov = el('bbOverlay');
    if (ov) ov.addEventListener('click', function (e) { if (e.target === ov) closePopup(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });

    /* Step 1 rows */
    qsa('.bb-pop-pkg-row[data-pkg]').forEach(function (row) {
      row.addEventListener('click', function () {
        selPkg = parseInt(row.getAttribute('data-pkg'));
        sizes = {}; qty = 1;
        showStep(2);
      });
    });

    /* Change pkg */
    var s2c = el('bbS2Change');
    if (s2c) s2c.addEventListener('click', function () { showStep(1); });

    /* Qty */
    var qm = el('bbQtyMinus');
    var qp = el('bbQtyPlus');
    if (qm) qm.addEventListener('click', function () { if (qty > 1) { qty--; el('bbQtyNum').textContent = qty; syncCost(); } });
    if (qp) qp.addEventListener('click', function () { qty++; el('bbQtyNum').textContent = qty; syncCost(); });

    /* Confirm */
    var cta = el('bbPopCta');
    if (cta) cta.addEventListener('click', confirmOrder);

    /* Package cards & final-pkgs → open with pkg */
    qsa('[data-open-pkg]').forEach(function (card) {
      card.addEventListener('click', function () {
        openWithPkg(card.getAttribute('data-open-pkg'));
      });
    });

    /* Fresh open buttons */
    qsa('[data-open-popup]').forEach(function (btn) {
      btn.addEventListener('click', openFresh);
    });

    /* Sticky scroll */
    var sticky = qs('.bb-sticky');
    if (sticky) {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('visible', window.scrollY > 500);
      }, { passive: true });
    }

    /* FAQ */
    qsa('.bb-faq-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var open = item.classList.contains('open');
        qsa('.bb-faq-item').forEach(function (i) {
          i.classList.remove('open');
          i.querySelector('.bb-faq-a').classList.remove('open');
        });
        if (!open) {
          item.classList.add('open');
          item.querySelector('.bb-faq-a').classList.add('open');
        }
      });
    });

    /* Galerie */
    initGallery();

    /* Slideshow hero */
    initHeroSlider();

    /* Video "De ce BINIBINI" */
    initWhyVideo();

    /* Urgență: stoc + countdown, actualizat live */
    updateTopbar();
    setInterval(updateTopbar, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Expose for Shopify sections */
  window.BB = { openFresh: openFresh, openWithPkg: openWithPkg, close: closePopup };
})();